import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';

import TextField from '../UI/TextField';

const Input = React.forwardRef((props, ref) => {
  const { helperText, counter, ...rest } = props;
  const [field, meta] = useField(props);

  const privateHelperText = counter ? `${field?.value?.length}/${counter}` : helperText;

  return (
    <TextField
      error={Boolean(meta.touched && meta.error)}
      helperText={(meta.touched && meta.error) || privateHelperText}
      {...field}
      {...rest}
      inputRef={ref}
    />
  );
});

Input.propTypes = {
  helperText: PropTypes.string,
};

Input.defaultProps = {
  helperText: null,
};

export default Input;
